// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"6fcf7b21","203":"64a277fd","228":"a21221cf","235":"8b34e996","429":"75681a9a","704":"9d90e051","744":"e121d1b6","927":"cd857cc1","955":"748ff088","985":"5dca08b8"}[chunkId] + ".chunk.js";
};